import axios from 'axios';
import config from '../../../common/config/env'; 
import { axiosAuthInterceptor } from './authInterceptor';

const koganAPI = axios.create({
    baseURL: `${config.koganAPIBaseUrl}`
    
});



koganAPI.interceptors.request.use(
    axiosAuthInterceptor,
    (error)=> Promise.reject(error)
);
export default koganAPI;